import { useCallback, useEffect, useState } from "react";
import { fetchIpdBedTypes, fetchIpdBeds } from "../api/registrationService";

// Wards (bed types) are facility-wide: a bed belongs to no department, so the
// ward step no longer depends on which department the wizard picked. The
// department is still asked for — it filters the Consultant list — but it no
// longer gates or narrows the beds on offer.
export function useBedAssignment(selectedWard) {
  const [bedTypeList, setBedTypeList] = useState([]);
  const [bedList, setBedList] = useState([]);
  const [loadingBedTypes, setLoadingBedTypes] = useState(false);
  const [loadingBeds, setLoadingBeds] = useState(false);

  useEffect(() => {
    let mounted = true;
    setLoadingBedTypes(true);
    fetchIpdBedTypes()
      .then((types) => { if (mounted) setBedTypeList(types); })
      .catch(() => { if (mounted) setBedTypeList([]); })
      .finally(() => { if (mounted) setLoadingBedTypes(false); });

    return () => { mounted = false; };
  }, []);

  useEffect(() => {
    const normalizedWard = String(selectedWard || "").trim();

    if (!normalizedWard) {
      setBedList([]);
      return;
    }

    const selectedBedType = bedTypeList.find((item) => item.bedTypeCode === normalizedWard);
    const bedTypeCodeForApi = selectedBedType?.originalBedTypeCode || normalizedWard;

    let mounted = true;
    setLoadingBeds(true);
    fetchIpdBeds(bedTypeCodeForApi)
      .then((beds) => { if (mounted) setBedList(beds); })
      .catch(() => { if (mounted) setBedList([]); })
      .finally(() => { if (mounted) setLoadingBeds(false); });

    return () => { mounted = false; };
  }, [selectedWard, bedTypeList]);

  const getSelectedWardDetails = useCallback(
    (wardCode) => bedTypeList.find((ward) => ward.bedTypeCode === wardCode),
    [bedTypeList]
  );

  return {
    bedTypeList,
    bedList,
    loadingBedTypes,
    loadingBeds,
    getSelectedWardDetails,
  };
}
